import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import { css } from "@emotion/core";
import BarLoader from "react-spinners/BarLoader";

const override = css
  `display: block;
  margin: 0 auto;
  width:200px;
  border-color: #35B9B6;`;

const useStyles = makeStyles({
  paperRoot: {
    backgroundColor: '#ffffff'
  },
  paperRootSolid: {
    backgroundColor: '#ffffff'
  },
});

export default props => {
  const classes = useStyles();
  const { loading } = props;

  return (

    <Dialog
      open={loading}
      fullScreen
      disableBackdropClick
      disableEscapeKeyDown
      PaperProps={props.full ? ({
        classes: { root: classes.paperRootSolid }
      }) : {
          classes: { root: classes.paperRoot }
        }

      }
    >
      <div className="flexContainer--center">
        <BarLoader
          css={override}
          size={300}
          color={"#35B9B6"}
          loading={loading}
        />
      </div>
    </Dialog>
  );
};
